import { h } from 'vue';

export const NotFound = <div>Not Found</div>;
